import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import cx from 'classnames';
import './styles.sass';
import IconSvg from 'components/IconSvg';
import ChatFormatting from 'assets/icons/chat-formatting.i.svg';
import ChatSubmit from 'assets/icons/chat-submit.i.svg';
import ChatBold from 'assets/icons/chat-bold.i.svg';
import ChatCursive from 'assets/icons/chat-cursive.i.svg';
import ChatStrikeThrough from 'assets/icons/chat-strikethrough.i.svg';
import ChatClose from 'assets/icons/chat-close.i.svg';
import AIPrompt from 'assets/icons/ai-prompt.i.svg';
import JobTaxAssistantPromptPicker from '../JobTaxAssistantPromptPicker';
import Input from '../../../jobs/components/QuestionsEditor/Input';
export var MobileMessageComposer = function MobileMessageComposer(props) {
  var isNoteMode = false;
  var border = props.border,
    disabled = props.disabled,
    onChange = props.onChange,
    onSend = props.onSend,
    value = props.value,
    jobTaxAssistantPrompts = props.jobTaxAssistantPrompts,
    onJobTaxAssistantPromptClick = props.onJobTaxAssistantPromptClick;
  var _React$useReducer = React.useReducer(function (state, newState) {
      return _objectSpread(_objectSpread({}, state), newState);
    }, {
      isFormattingOpen: false,
      isAIPromptPickerOpen: false
    }),
    _React$useReducer2 = _slicedToArray(_React$useReducer, 2),
    state = _React$useReducer2[0],
    setState = _React$useReducer2[1];
  function sendMessage() {
    onSend(isNoteMode);
    onChange('');
  }
  function execEditorAction(action) {
    if (action === 'toggleBold') {
      onChange("**".concat(value, "**"));
    } else if (action === 'toggleItalic') {
      onChange("*".concat(value, "*"));
    } else if (action === 'toggleStrikethrough') {
      onChange("~~".concat(value, "~~"));
    }
  }
  return /*#__PURE__*/React.createElement("div", {
    className: cx('message-composer', disabled && 'is-disabled', border && 'has-border', isNoteMode && 'note'),
    "data-test": "message-composer"
  }, state.isAIPromptPickerOpen && /*#__PURE__*/React.createElement(JobTaxAssistantPromptPicker, {
    prompts: jobTaxAssistantPrompts,
    onPromptClick: onJobTaxAssistantPromptClick,
    onClose: function onClose() {
      return setState({
        isAIPromptPickerOpen: !state.isAIPromptPickerOpen
      });
    }
  }), /*#__PURE__*/React.createElement(Input, {
    className: "input-editor",
    placeholder: "Type a message...",
    value: value,
    onChange: onChange,
    autocapitalize: "sentences",
    multi: true
  }), /*#__PURE__*/React.createElement("div", {
    className: "toolbar"
  }, !state.isFormattingOpen && /*#__PURE__*/React.createElement("div", {
    className: "toolbar-actions"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setState({
        isFormattingOpen: !state.isFormattingOpen
      });
    }
  }, /*#__PURE__*/React.createElement(IconSvg, {
    color: "var(--theme-base)",
    size: 48
  }, /*#__PURE__*/React.createElement(ChatFormatting, null))), (jobTaxAssistantPrompts === null || jobTaxAssistantPrompts === void 0 ? void 0 : jobTaxAssistantPrompts.length) > 0 && /*#__PURE__*/React.createElement("button", {
    className: "toggle-prompt-picker-button",
    onClick: function onClick() {
      return setState({
        isAIPromptPickerOpen: !state.isAIPromptPickerOpen
      });
    }
  }, /*#__PURE__*/React.createElement(IconSvg, {
    size: 24
  }, /*#__PURE__*/React.createElement(AIPrompt, null)))), state.isFormattingOpen && /*#__PURE__*/React.createElement("div", {
    className: "toolbar-actions"
  }, /*#__PURE__*/React.createElement("button", {
    className: "close",
    onClick: function onClick() {
      return setState({
        isFormattingOpen: !state.isFormattingOpen
      });
    }
  }, /*#__PURE__*/React.createElement(IconSvg, {
    size: 48
  }, /*#__PURE__*/React.createElement(ChatClose, null))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return execEditorAction('toggleBold');
    }
  }, /*#__PURE__*/React.createElement(IconSvg, {
    color: "var(--theme-base)",
    size: 48
  }, /*#__PURE__*/React.createElement(ChatBold, null))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return execEditorAction('toggleItalic');
    }
  }, /*#__PURE__*/React.createElement(IconSvg, {
    color: "var(--theme-base)",
    size: 48
  }, /*#__PURE__*/React.createElement(ChatCursive, null))), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return execEditorAction('toggleStrikethrough');
    }
  }, /*#__PURE__*/React.createElement(IconSvg, {
    color: "var(--theme-base)",
    size: 48
  }, /*#__PURE__*/React.createElement(ChatStrikeThrough, null)))), /*#__PURE__*/React.createElement("button", {
    onClick: sendMessage
  }, /*#__PURE__*/React.createElement(IconSvg, {
    color: "var(--theme-base)",
    size: 48
  }, /*#__PURE__*/React.createElement(ChatSubmit, null)))));
};
//# sourceMappingURL=index.js.map
